import { createServiceFactory } from '@/services/factory'
import { createMockNoteService } from './notes.mock'
import { createHttpNoteService } from './notes.http'

export type { NoteService } from './notes.service'

export const getNoteService = createServiceFactory(
  'notes',
  createMockNoteService,
  createHttpNoteService
)
